import type { GroupSecurity } from '@quromedical/fhir-common';
import { useUserSession } from 'hooks/useUserSession';
import type React from 'react';
import type { PropsWithChildren } from 'react';

interface BaseWithGroupProps {
  groups: GroupSecurity[];
}

type WithGroupProps = PropsWithChildren<BaseWithGroupProps>;

/**
 * Ensures that the contents of a section are only available to users with the provided `group`
 */
export const WithGroup: React.FC<WithGroupProps> = ({ groups, children }) => {
  const session = useUserSession();
  const hasGroup = session.hasAny(groups);

  if (!hasGroup) {
    return null;
  }

  return <>{children}</>;
};
